import script from "./IncomeStatementFundSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeStatementFundSummary.vue?vue&type=script&setup=true&lang=js"

import "./IncomeStatementFundSummary.vue?vue&type=style&index=0&id=91a0c348&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91a0c348"]])

export default __exports__